import {Component, Input} from '@angular/core';

@Component({
  selector: 'digires-chevron-vertical',
  templateUrl: './chevron-vertical.component.html',
  styleUrls: ['./chevron-vertical.component.scss']
})
export class ChevronVerticalComponent {

  @Input() label: string;
  @Input() highlight: boolean;
  @Input() minHeight = '200px';
  @Input() fontSize = 'medium';

}
